import { ROW_COUNT, ROW_COUNT_MAX } from "./variableHelper";

export const cParamsPageSize = (pageSize: number) => {
  return {
    PAGINA: 1,
    PAGINADO: pageSize,
    ORDENADOPOR: "ID",
    ORIENTACION: "DESC",
    ACTIVO: true,
  };
};

export const cParamsActive = {
  PAGINA: 1,
  PAGINADO: ROW_COUNT_MAX,
  ORDENADOPOR: "ID",
  ORIENTACION: "ASC",
  ACTIVO: true,
};

export const cParamsActiveOrderTitle = {
  PAGINA: 1,
  PAGINADO: ROW_COUNT_MAX,
  ORDENADOPOR: "TITULO",
  ORIENTACION: "ASC",
  ACTIVO: true,
};

export const cParamsActiveOrderNombre = {
  PAGINA: 1,
  PAGINADO: ROW_COUNT_MAX,
  ORDENADOPOR: "NOMBRE",
  ORIENTACION: "ASC",
  ACTIVO: true,
};

export const cParams = {
  PAGINA: 1,
  PAGINADO: ROW_COUNT,
  ORDENADOPOR: "ID",
  ORIENTACION: "DESC",
  ACTIVO: true,
};
